'use strict';

import {Offcanvas, Dropdown} from 'bootstrap';

export class Header {
  constructor() {
    this.initListeners();
    this.handleScroll();
    this.handleResize();
  }

  get headerDomElement() {
    return document.querySelector('header') || false;
  }

  get offcanvasDomElement() {
    if (!this.headerDomElement) return;
    return this.headerDomElement.querySelector('.offcanvas') || false;
  }

  get dropdownDomElements() {
    if (!this.headerDomElement) return;
    return this.headerDomElement.querySelectorAll('.dropdown');
  }

  handleScroll = () => {
    const atTop = window.scrollY >= 50;
    if (atTop) this.headerDomElement.setAttribute('data-scrolled', 'true');
    else this.headerDomElement.setAttribute('data-scrolled', 'false');
  }

  handleResize = () => {
    const isXl = window.matchMedia('(min-width: 1441px)').matches;
    const offcanvasElement = Offcanvas.getOrCreateInstance(this.offcanvasDomElement)
    if (isXl) {
      offcanvasElement.hide();
    }
  }

  initListeners() {
    if (!this.headerDomElement) return;
    if (this.offcanvasDomElement) {
      this.offcanvasDomElement.addEventListener('hide.bs.offcanvas', () => {
        this.headerDomElement.setAttribute('data-offcanvas', 'hiding');
      });
      this.offcanvasDomElement.addEventListener('hidden.bs.offcanvas', () => {
        this.headerDomElement.setAttribute('data-offcanvas', 'hidden');
      });
      this.offcanvasDomElement.addEventListener('show.bs.offcanvas', () => {
        this.headerDomElement.setAttribute('data-offcanvas', 'showing');
      });
      this.offcanvasDomElement.addEventListener('shown.bs.offcanvas', () => {
        this.headerDomElement.setAttribute('data-offcanvas', 'visible');
      });
    }

    this.dropdownDomElements.forEach(dropdownElement => {
      const dropdownToggleElement = dropdownElement.querySelector('.dropdown-toggle');

      dropdownElement.onmouseover = () => {
        const dropdownInstance = Dropdown.getOrCreateInstance(dropdownToggleElement);
        dropdownInstance.show();
      }

      dropdownElement.onmouseleave = () => {
        const dropdownInstance = Dropdown.getOrCreateInstance(dropdownToggleElement);
        dropdownInstance.hide();
      }
    })
  }
}
